// Component-level anchor classification. Buttons, image buttons, and forms are components on a
// page (with ids like "form-1"), not nodes in the dag, so their anchor helpers live here rather
// than in the graph module. The dag imports these to order sibling edges by their source anchor.
export const BUTTON_ANCHOR_BASE_NAME = "button";
export const IMAGE_BUTTON_ANCHOR_BASE_NAME = "image-button";
export const FORM_ANCHOR_BASE_NAME = "form";

export function isButtonAnchor(anchor: string | undefined): boolean {
	return anchor === BUTTON_ANCHOR_BASE_NAME || (anchor?.startsWith(`${BUTTON_ANCHOR_BASE_NAME}-`) ?? false);
}

export function isImageButtonAnchor(anchor: string | undefined): boolean {
	return anchor === IMAGE_BUTTON_ANCHOR_BASE_NAME || (anchor?.startsWith(`${IMAGE_BUTTON_ANCHOR_BASE_NAME}-`) ?? false);
}

export function isFormAnchor(anchor: string | undefined): boolean {
	return anchor === FORM_ANCHOR_BASE_NAME || (anchor?.startsWith(`${FORM_ANCHOR_BASE_NAME}-`) ?? false);
}
